import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocaleResolve } from 'src/app/core/locale/locale.resolve';
import { OrderTypeGuard } from 'src/app/pages/account/guards/order-type.guard';
import { DashboardComponent } from 'src/app/pages/profile-overview/components/dashboard/dashboard.component';

const routes: Routes = [
	{
		path: '',
		component: DashboardComponent,
		data: {
			locales: ['dashboard'],
		},
		canActivate: [OrderTypeGuard],
		resolve: {
			locales: LocaleResolve,
		},
	},
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule],
})
export class ProfileOverviewRoutingModule {}
